import {Box, Stack, Typography} from '@mui/material';
import React, {useCallback} from 'react';
import {useNavigate, useSearchParams} from 'react-router-dom';

import {MainFooter, MainHeader, PageWrapperLayout} from 'presentation/components';
import {Filter} from 'presentation/components/Filter';
import {HomeEnum} from 'presentation/constants';
import {translations} from 'presentation/translations-new';
import {ConciergeDrawer} from 'presentation/components/ConciergeDrawer';
import {useMediaQueries} from '../hooks';
import {EmptyState} from './components';
import {useServicesListForShortcuts} from '../hooks/useServicesListForShortcuts';
import {useServicesList} from '../hooks/useServicesList';
import {OtherServices} from './components/OtherServices';
import {ShortcutList} from '../home/components/ShortcutList';
import {useHostName} from 'presentation/hooks';
import {NotredameOtherServices} from './components/NotredameOtherServices';
import {useNotredameServicesList} from '../hooks/useNotredameServicesList';

const {mainServices, searchService} = translations['pt-br'].privateFlow.services;
const {services} = translations['pt-br'].others.sidebar;

export function Services() {
	const navigate = useNavigate();
	const {isMobile} = useMediaQueries();
	const [searchParams] = useSearchParams();
	const query = searchParams.get('q') || '';
	const {isServiceListEmpty} = useServicesList(query);
	const {isServiceListEmpty: isNotredameServiceListEmpty} = useNotredameServicesList(query);
	const {isShortcutsListEmpty} = useServicesListForShortcuts(query);
	const {isNotredameSaude} = useHostName();

	const isListEmptyFinal = isNotredameSaude ? isNotredameServiceListEmpty : isServiceListEmpty;
	const isEmpty = isListEmptyFinal && isShortcutsListEmpty;

	const handleBack = useCallback(() => {
		navigate(HomeEnum.HOME_PAGE);
	}, []);

	const OtherServicesComponent = isNotredameSaude ? NotredameOtherServices : OtherServices;

	return (
		<PageWrapperLayout title={services}>
			<MainHeader title={services} handleBack={handleBack} />
			<Filter.Root>
				<Filter.Search placeholder={searchService} />
			</Filter.Root>
			{isEmpty ? (
				<EmptyState />
			) : (
				<Stack p={isMobile ? 2 : 4}>
					{isShortcutsListEmpty || isNotredameSaude ? null : (
						<Stack marginBottom={3}>
							<Typography
								variant="subtitle1"
								color="text.secondary"
								fontWeight={700}
								mb={isMobile ? 1 : 2}>
								{mainServices}
							</Typography>
							<ShortcutList query={query} />
						</Stack>
					)}

					{isListEmptyFinal ? null : <OtherServicesComponent query={query} />}
				</Stack>
			)}

			<ConciergeDrawer />
			<Box mt="auto">
				<MainFooter />
			</Box>
		</PageWrapperLayout>
	);
}
